export default {"src":"/_next/static/media/rigthCheck.92707cf4.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};